<div class="panel_container">
  <div class="detail_evt_fermer">
    <button
      type="button"
      appButton
      variant="ghost"
      iconOnly
      icon="x"
      class="btn_fermer"
      label="Fermer le panneau"
      (click)="fermerSlider()"
    ></button>
  </div>

  <h2>Sélectionner un ou plusieurs abonnements</h2>
  <div class="abonnement_select">
    <!-- `app-select` travaille sur des CLÉS : `idFormule` sert de clé et les états
         connus passent par le `suffix` de l'option, là où Material imbriquait des
         `mat-chip` dans le contenu de l'option. -->
    <app-form-field label="Abonnements">
      <app-select
        label="Sélectionner des abonnements"
        trigger="field"
        selectionMode="multi"
        [fullWidth]="true"
        [clearable]="true"
        [options]="optionsAbonnements()"
        [selected]="clesAbonnementsSelectionnes()"
        (selectionChange)="choisirAbonnements($event)"
      />
    </app-form-field>
  </div>

  @if (clesAbonnementsSelectionnesSource()?.length) {
    <h2>Abonnement(s) sélectionné(s)</h2>
    <div class="abonnement_selection">
      <ul class="liste_selection" role="list">
        @for (element of clesAbonnementsSelectionnesSource() ?? []; track element.idFormule) {
          <li class="abonnement_selection_element">
            {{ element.idAparte }} - {{ element.nom }}
            @if (element.parametrageSpecifique) {
              <app-pill label="déjà un paramétrage spécifique" tone="warning" />
            }
            <button
              type="button"
              appButton
              variant="ghost"
              size="sm"
              iconOnly
              icon="x"
              label="Retirer de la sélection"
              appTooltip="Retirer de la sélection"
              (click)="retirerAbonnementDeLaSelection(element)"
            ></button>
          </li>
        }
      </ul>
    </div>

    <div class="regle_container">
      <form [formGroup]="reglesForm">
        <h2>Sélectionner une règle</h2>
        <div class="regle_card">
          <div class="regle_form_row" formGroupName="regle">
            <app-form-field label="Pourcentage à appliquer" class="dialog_form_field">
              <app-input
                inputMode="decimal"
                [allowedChars]="chiffres"
                suffix="%"
                formControlName="pourcentage"
                (committed)="normaliserTaux(reglesForm.controls.regle.controls.pourcentage)"
              />
              @if (pourcentageHorsBornes()) {
                <span appFieldError>Un pourcentage entre 0 et 100</span>
              }
            </app-form-field>
            <app-form-field label="Montant à appliquer" class="dialog_form_field">
              <app-input
                inputMode="decimal"
                [allowedChars]="chiffres"
                suffix="€"
                formControlName="minimum"
                (committed)="normaliserMontant(reglesForm.controls.regle.controls.minimum)"
              />
            </app-form-field>
          </div>
          @if (regles().regle?.minimum) {
            <div class="preview">
              {{ reglePourAbonnementLibelle() }}
            </div>
          }
        </div>
      </form>
    </div>
  }
  <div class="footer_container">
    <button type="button" appButton variant="secondary" (click)="fermerSlider()">Annuler</button>
    <button type="button" appButton variant="primary" [disabled]="!reglesValides()" (click)="valider()">Valider</button>
  </div>
</div>
